import { jsx as _jsx } from "react/jsx-runtime";
import useLayoutStyles from './useLayoutStyles';
import { Box } from '@mui/material';
import AppLayout from './AppLayout';
const Layout = () => {
    const styles = useLayoutStyles();
    return (_jsx(Box, { sx: { ...styles.layoutMainContainer }, children: _jsx(AppLayout, {}) }));
};
export default Layout;
